// Правила формы чека. Salomat получает их с сервера в meta.form
// (AttachmentBlueprint); у PharmIQ meta.form нет, и форма остаётся прежней.

// Только цифры, не больше maxLength (STIR аптеки)
export const digitsOnly = (value, maxLength) => value.replace(/\D/g, "").slice(0, maxLength);

// Свойства поля STIR аптеки на Salomat: вводятся только цифры, не больше pharmacyInnLength
export const pharmacyInnInputProps = (form = {}, setFieldValue) => (form.pharmacyInnLength ? {
  inputMode: "numeric",
  onChange: (event) => setFieldValue("pharmacyInn", digitsOnly(event.target.value, form.pharmacyInnLength)),
} : {});

// Кол-во упаковок — целое число от 1: дробь, знак и ведущий ноль не вводятся
export const wholePackages = (value, previous) => (/^\d*$/.test(value) ? value.replace(/^0+/, "") : previous);

// Кол-во упаковок без дробной части из decimal сервера ("2.0" -> "2")
export const packages = (value) => (value === "" || value === null || value === undefined ? "" : String(+value));

// Общая стоимость позиции: количество × цена, с точностью до копеек/тийинов
export const lineTotal = ({ quantity, amount }) => Math.round(+quantity * +amount * 100) / 100;

// Сумма по позициям чека: на Salomat — по общей стоимости позиций
export const purchasesTotal = (purchases, form = {}) => (form.editableLineTotals
  ? Math.round(purchases.reduce((total, e) => total + +e.totalAmount, 0) * 100) / 100
  : purchases.reduce((total, e) => total + +e.amount * +e.quantity, 0));

export const newPurchase = (form = {}) => ({
  name: "",
  quantity: form.wholePackages ? 1 : 0,
  quantityByPrescription: 0,
  dosage: 0,
  amountInPackage: 0,
  amount: 0,
  releaseForm: '',
  includedInPrescription: "",
  excludedFromProgram: "",
  excludedFromProgramReasons: [],
  ...(form.editableLineTotals ? { totalAmount: 0 } : {}),
});

// Свойства полей количества и цены позиции на Salomat: целые упаковки, а общая
// стоимость пересчитывается при их изменении и иначе остаётся введённой вручную
export const purchaseInputProps = (form = {}, purchase, name, setFieldValue) => {
  const change = (field, value) => {
    if (value === purchase[field]) return;

    setFieldValue(`${name}.${field}`, value);
    if (form.editableLineTotals) {
      setFieldValue(`${name}.totalAmount`, lineTotal({ ...purchase, [field]: value }));
    }
  };

  return {
    quantity: form.wholePackages ? {
      type: "text",
      inputMode: "numeric",
      value: packages(purchase.quantity),
      onChange: (event) => change("quantity", wholePackages(event.target.value, purchase.quantity)),
    } : {},
    amount: form.editableLineTotals ? { onChange: (event) => change("amount", event.target.value) } : {},
  };
};
